import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import da from "@/content/da";
import { ExplorerProvider } from "@/context/ExplorerContext";
import { useLenis } from "@/hooks/useLenis";
import { PawProgress } from "@/components/lurio/PawProgress";
import { StickyBar } from "@/components/lurio/StickyBar";
import { FloatingWhatsApp } from "@/components/lurio/FloatingWhatsApp";
import Hero from "@/sections/Hero";
import TrustStrip from "@/sections/TrustStrip";
import Promise from "@/sections/Promise";
import MeetNori from "@/sections/MeetNori";
import InsideBook from "@/sections/InsideBook";
import Badges from "@/sections/Badges";
import Credibility from "@/sections/Credibility";
import Quality from "@/sections/Quality";
import Diplome from "@/sections/Diplome";
import OrderForm from "@/sections/OrderForm";
import FAQ from "@/sections/FAQ";
import FinalCTA from "@/sections/FinalCTA";
import Footer from "@/sections/Footer";
import AdminOrders from "@/pages/AdminOrders";

const Landing = () => {
  useLenis();
  return (
    <>
      <PawProgress />
      <a href="#commander" className="sr-only focus:not-sr-only focus:fixed focus:start-4 focus:top-10 focus:z-[60] focus:rounded-full focus:bg-coral focus:px-4 focus:py-2 focus:text-cream">
        {da.nav.order}
      </a>
      <div aria-hidden className="spine fixed inset-y-0 start-0 z-40 hidden w-7 lg:block" />
      <header className="absolute inset-x-0 top-8 z-30 flex items-center justify-center px-5 sm:px-8 lg:px-14">
        <a href="#hero" data-testid="logo" className="inline-flex items-center">
          <img src="/logo.png" alt={da.brand} className="h-8 w-auto sm:h-9" loading="eager" decoding="async" />
        </a>
      </header>
      <main className="lg:ps-7">
        <Hero />
        <TrustStrip />
        <Promise />
        <MeetNori />
        <InsideBook />
        <Badges />
        <Credibility />
        <Quality />
        <Diplome />
        <OrderForm />
        <FAQ />
        <FinalCTA />
      </main>
      <div className="lg:ps-7">
        <Footer />
      </div>
      <StickyBar />
      <FloatingWhatsApp />
    </>
  );
};

function App() {
  return (
    <div className="App" dir={da.dir} lang={da.lang}>
      <ExplorerProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin" element={<Navigate to="/admin/orders" replace />} />
            <Route path="/admin/orders" element={<AdminOrders />} />
          </Routes>
        </BrowserRouter>
      </ExplorerProvider>
    </div>
  );
}

export default App;
